import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { FormInput } from '../../components/FormInput';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { checkDpSuccess, getCompanyType } from '../../utility/service/tool-service';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { SystemLoading,checkLoading } from '../../store/loadingStore';
import { queryFeUsersList, suspendFeUsersInfo, unlockUserAccount } from '../../utility/service/account-service';
import { MessageContext,handleSuccessMessage } from '../../store/messageStore';
import { CusCompanyAcctList } from '../companyList/CusCompanyAcctList';
import { getSubItemsByItemNo } from '../../utility/service/api-service';
import { useEditableFlag } from '../../hooks/useEditableFlag';
import { AcctContext } from '../../utility/useReduce/userNameReduce';

const AccountList_Index = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [,loading] = useContext(SystemLoading);
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [rows,setRows] = useState([]);
    const [userSeq ,setUserSeq ] = useState('');
    const [delDialog,setDelDialog] = useState(false);
    const [delObj,setDelObj] = useState({});
    const [, dispatch] = useContext(MessageContext); //訊息視窗
    const [userStatusList,setUserStatusList] = useState([]);
    const isEditable = useEditableFlag('B10101'); // Get editable status for B10101 function
    
    //
  
    
    const esgClientId = [
        {
            label:t('company.a'),
            value:'A'
        },
        {
            label:t('company.b'),
            value:'B'
        },
        {
          label:t('company.m'),
          value:'M'
      }
    ]

    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
            keywordSearch:'',
            companyType:'',
            status:''
        },
        //錯誤驗證時機
        mode: "all"
      });

    const onSubmit = (data)=>{
        let reqBody = {
          keywordSearch:data.keywordSearch,
        }
        if(data.companyType!==''){
          reqBody.companyType = data.companyType
        }
        if(data.status!==''){
          reqBody.status = data.status
        }
        axios_queryFeUsersList(reqBody);
        
    }

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }

    const confirmDel =()=>{
      suspendFeUsersInfo({userSeq:delObj?.userSeq})
        .then((res)=>{
          if(checkDpSuccess(res)){
            handleSuccessMessage(dispatch, t('button.delete') + ' ' + t('message.success'));
            let reqBody = {
              keywordSearch:getValues("keywordSearch"),
            }
            if(getValues("companyType")!==''){
              reqBody.companyType = getValues("companyType")
            }

            if(getValues("status")!==''){
              reqBody.status = getValues("status")
            }

            axios_queryFeUsersList(reqBody);
            setDelDialog(false);
          }
        })
    }

     //查詢更多
    const btnReadMore = () => {
      let reqBody = {
        keywordSearch:getValues("keywordSearch"),
        userSeq:userSeq
      }
      if(getValues("companyType")!==''){
        reqBody.companyType = getValues("companyType")
      }
 
      axios_queryFeUsersList(reqBody,true);
    };

    const editItem = (item,act)=>{
      setItemObj(item);
      navigate(act);
      setAction(act);
    }

    const deleteItem = (item)=>{
      setDelDialog(true);
      setDelObj(item);
    }

    const unlockItem = (item)=>{
      unlockUserAccount({userSeq:item?.userSeq})
        .then((res)=>{
          if(checkDpSuccess(res)){
            handleSuccessMessage(dispatch, t('button.unlock') + ' ' + t('message.success'));
            let reqBody = {
              keywordSearch:getValues("keywordSearch"),
            }
            if(getValues("companyType")!==''){
              reqBody.companyType = getValues("companyType")
            }

            if(getValues("status")!==''){
              reqBody.status = getValues("status")
            }
            axios_queryFeUsersList(reqBody);
            
          }
        })
    }

    useEffect(()=>{
      let comType = ""
      if(JSON.stringify(currentStatus)!=='{}'){
          comType = currentStatus?.companyType
      }else{
          comType = ""
      }
      setValue("companyType",comType, {shouldValidate:true});
      axios_queryFeUsersList({companyType:comType});
      axios_getUserStatusList();
    },[])

    const axios_queryFeUsersList = (reqBody,readMore=false)=>{
      setCurrentStatus({
        companyType:reqBody?.companyType
      })
      checkLoading(loading);
      queryFeUsersList(reqBody)
        .then((res)=>{
          if(checkDpSuccess(res)){
              let data = res?.data?.RespBody?.userList;
              if(data?.length > 0){
                setUserSeq(data[data?.length-1].userSeq);
                  if(readMore===true){
                    setRows((pre)=>{
                      return [...pre,...data] 
                    })
                  }else{
                    setRows((pre)=>{
                      return [...data]
                    });
                  }
                }else{
                  if(readMore===false){
                    setRows([]);
                  }
                }
              
          }else{
              if(readMore===false){
                setRows([]);
              }
            }
      }).finally((fin)=>{checkLoading(loading,false);})
  }

  const axios_getUserStatusList = ()=>{
    getSubItemsByItemNo('USER_STATUS',22)
    .then((res)=>{
        if(checkDpSuccess(res)){
            let data = res.data.RespBody.subItems;
            let newArray = data.map((item, index) => {
              return {
                ...item,
                index: index,
              }
            })
            setUserStatusList(newArray);
        }
    })
  }



  return (
    <>
    <CusCompanyAcctList 
      rows={rows} 
      btnReadMore={btnReadMore} 
      editItem={editItem} 
      delDialog={delDialog} 
      setDelDialog={setDelDialog}
      confirmDel={confirmDel}
      delObj={delObj}
      deleteItem={deleteItem}
      unlockItem={unlockItem}
      isType="Y"
      isEditable={isEditable}>
    <form className="flex flex-wrap align-items-center col-12" onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
                {
                  getCompanyType()==='M'&& (
                <div className='col-12 lg:col-3'>
                    <label
                        htmlFor="companyType"
                        className="form-label">
                        {t("useType")}
                    </label>
                <Controller
                    name="companyType"
                    control={control}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            filter
                            showClear
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs_all")}
                            name="companyType"
                            control={control}
                            options={esgClientId}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )}
                />

                </div>
                  )
                }
                
           
            <div className={`col-12 lg:col-${getCompanyType()!=='M'?'6':'6'}`}>
              <FormInput
                register={register}
                errors={errors}
                id="keywordSearch"
                type="text"
                placeholder={`${t('user_name')}、${t('user_email')}`}
                labelClass="control-label"
                enterClick={checkKeyDown}
                labelText={t('keyword')}
                
              />
            </div>
            <div className={`col-12 lg:col-${getCompanyType()!=='M'?'6':'3'}`}>

            <label
                    htmlFor="status"
                    className="form-label">
                    {t("status")}
                </label>
                <Controller
                    name="status"
                    control={control}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            showClear
                            filter
                            optionLabel="subitemName"
                            optionValue="subitemNo"
                            value={field.value}
                            virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs_all")}
                            name="status"
                            control={control}
                            options={userStatusList}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )}
                />

            </div>
            <div className="col-12 gap-2 flex-all-center">
                <Button disabled={!isValid} type="submit" label={t("button.query")} />
            </div>


            </form>

    </CusCompanyAcctList>
    </>
    
  )
}

export default AccountList_Index